import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const ArticleHeader = ({ post, author, date }) => (
    <header className="bg-navy text-cream">
        <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 pt-8 md:pt-12 lg:pt-16 pb-10 md:pb-14 lg:pb-[72px] flex flex-col gap-[18px] animate-fade-up">
            <Link to="/actualites" data-testid="article-back-link" className="self-start inline-flex items-center gap-1.5 min-h-[44px] text-sm text-on-navy-soft hover:text-cream transition-colors">
                <ArrowLeft size={16} /> Retour aux actualités
            </Link>
            {post.category && <span className="text-[13px] font-semibold uppercase tracking-[0.16em] text-gold">{post.category}</span>}
            <h1 className="m-0 font-bold text-[28px] md:text-[40px] lg:text-[50px] leading-[1.15] tracking-[-0.025em] text-cream max-w-[920px]">{post.title}</h1>
            <div className="flex items-center gap-3 text-sm text-on-navy-soft" data-testid="article-author">
                {author.photo && <img src={author.photo} alt="" width={40} height={40} className="w-10 h-10 rounded-full object-cover" />}
                <span>
                    Par{" "}
                    <Link to="/a-propos" className="text-cream underline underline-offset-2 hover:text-gold transition-colors">
                        {author.displayName || author.name}
                    </Link>{" "}
                    · {date}
                </span>
            </div>
        </div>
    </header>
);

export const ArticleAside = ({ toc }) => (
    <aside className="flex-1 basis-[280px] min-w-0 flex flex-col gap-5 lg:sticky lg:top-6">
        {toc.length > 0 && (
            <nav aria-label="Sommaire de l'article" data-testid="article-toc" className="bg-white border border-border-default rounded-[14px] p-[22px] flex flex-col gap-2.5 text-sm">
                <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gold-text">Dans cet article</span>
                {toc.map((t) => (
                    <a key={t.id} href={`#${t.id}`} className="py-1 text-navy hover:text-gold-text transition-colors">
                        {t.text}
                    </a>
                ))}
            </nav>
        )}
        <div className="bg-navy text-cream rounded-[14px] p-6 flex flex-col gap-3.5">
            <span className="text-xl font-bold leading-[1.3]">Et votre entreprise, combien paie-t-elle de trop ?</span>
            <span className="text-sm leading-relaxed text-on-navy-soft">Estimation en 30 secondes, anonyme et sans engagement.</span>
            <Link to="/simulateur" data-testid="article-aside-cta" className="h-12 flex items-center justify-center rounded-md bg-gold text-navy text-[15px] font-semibold transition-[transform,box-shadow] hover:-translate-y-[1px] hover:shadow-lg">
                Simuler mes économies
            </Link>
        </div>
    </aside>
);

export const RelatedPosts = ({ posts }) =>
    posts.length > 0 && (
        <section data-testid="article-suggestions" className="bg-cream border-t border-border-default">
            <div className="mx-auto max-w-[1180px] px-4 md:px-8 lg:px-12 py-10 md:py-14 lg:py-[72px] flex flex-col gap-6">
                <h2 className="m-0 font-bold text-2xl md:text-[32px] tracking-[-0.02em] text-navy">À lire aussi</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {posts.map((s) => (
                        <Link
                            key={s.id}
                            to={`/post/${s.slug}`}
                            data-testid={`suggestion-${s.slug}`}
                            className="group bg-white border border-border-default rounded-xl p-[22px] flex flex-col gap-2.5 text-navy transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
                        >
                            {s.category && <span className="text-xs font-semibold uppercase tracking-[0.12em] text-gold-text">{s.category}</span>}
                            <span className="text-[17px] font-bold leading-[1.35] group-hover:text-gold-text transition-colors">{s.title}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
